import { api } from "app/data/api";

export const getDivisions = async () => {
    return await api.get('/division/list')
}

export const registerDivision = async (values:any) => {
    return api.post('/division/register', {
        ...values
    })
}

export const editDivision = async (data) => {
    return await api.put("/division/edit", {
      ...data
    })
  }